import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helpText?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helpText, className = '', id, ...props }, ref) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
    const errorClass = error ? 'error' : '';

    return (
      <div className="form-group">
        {label && (
          <label htmlFor={inputId} className="form-label">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`form-input ${errorClass} ${className}`}
          {...props}
        />
        {error && <span className="form-error">{error}</span>}
        {helpText && !error && <span className="form-help">{helpText}</span>}
      </div>
    );
  },
);

Input.displayName = 'Input';

export default Input;
